import React from 'react';
import {connect} from 'react-redux';

import {BaseRate, mapStateToProps} from './BaseRate.jsx';

import {addCouponRate as addCouponRateAction, addRate as addRateAction} from 'actions/creators/CouponRate';
import {makeBet as makeBetAction} from 'actions/creators/MakeBet';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';

import {getRateDisplayValue} from 'rendering-commons';

class TennisGameRate extends BaseRate {
    constructor(props) {
        super(props);
    }

    render() {
        const {rate, outcomeIsBlocked} = this.props;

        if (rate === undefined) {
            return false;
        }

        const rateName = rate.get('shortName');

        let rateValue = getRateDisplayValue(rate.get('value'));
        const isVisible = rate.get('isVisible');

        if (!isVisible) {
            rateValue = '';
        }

        const isBlocked = rate.get('isBlocked') || outcomeIsBlocked;

        const rateCls = 'inner-rate' + (isBlocked ? ' closed' : '');
        const conditionCls = 'rate-name' + (isBlocked ? ' closed' : '');

        return (<span key={rate.get('id')} ref="rate" className="out-rate" onClick={this._onClick}>
                    <span className={conditionCls}>{rateName}</span>
                    <span className={rateCls}>{rateValue}</span>
                </span>);
    }
}

export default connect(mapStateToProps, {
    addCouponRateAction, makeBetAction, requestBetTypesAction, addRateAction
}, null, false)(TennisGameRate);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/rates/TennisGameRate.jsx